import { render } from "./nahalMasshaWest.vue?vue&type=template&id=b8246a6e&scoped=true"
import script from "./nahalMasshaWest.vue?vue&type=script&lang=js"
export * from "./nahalMasshaWest.vue?vue&type=script&lang=js"

import "./nahalMasshaWest.vue?vue&type=style&index=0&id=b8246a6e&scoped=true&lang=css"

import exportComponent from "/media/rafa/mainDisk/Documents/Raphael/Development/NavigationApplication/efoani/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8246a6e"]])

export default __exports__